import { Component, OnInit, ViewChild } from '@angular/core';
import { SettingsService } from '../../../services/settings.service';
import { Router } from '@angular/router';
import { SharedService } from '../../../services/shared.service';
import { PatientService } from '../../../services/patient.service';
import { FormControl } from '@angular/forms';
import { Observable, EMPTY, of, forkJoin } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})
export class SettingsDoctorCreateComponent implements OnInit {

  public doctors: any[];
  usersFilter: any[];
  users: any[];
  userId: string = "";
  patientId: number = 0;
  residents: any = [];
  condition: boolean;
  showSuccessMessage: boolean;
  public showLoadingMessage: boolean = false;
  public patientDtos: any[] = [];
  errorMessage: string = "";
  showErrorMessage: boolean = false;
  selectedDoctors: any[] = [];
  public filteredPatientDtos: any[] = [];
  public searchControl = new FormControl();


  constructor(private settingsService: SettingsService,
    private patientService: PatientService,
    private router: Router,
    private sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.sharedService.facilityUnitId = 0;
    
    // Preload usersFilter
    this.settingsService.getUserDoctors(this.sharedService.pharmacyId, this.sharedService.facilityId).subscribe(data => {
      this.usersFilter = data;
    });

    this.loadPatientDtos();
  }


  private loadPatientDtos() {
    this.showLoadingMessage = true;
    // Load ALL patients for the facility (pass empty userId)
    this.patientService.getPatientsByDoctorUserId(this.sharedService.pharmacyId, this.sharedService.facilityId, this.sharedService.getUserId(), true, "").subscribe(patientDtos => {
      this.patientDtos = patientDtos;
      // Initialize assignments tracking
      this.patientDtos.forEach(p => p.assignments = {});
      this.filteredPatientDtos = this.patientDtos;
      
      // Check for existing assignments for all doctors
      if (this.usersFilter && this.usersFilter.length > 0) {
        let completedRequests = 0;
        this.usersFilter.forEach(doctor => {
             this.patientService.getPatientsByDoctorUserId(this.sharedService.pharmacyId, this.sharedService.facilityId, this.sharedService.getUserId(), true, doctor.id)
            .subscribe(assignedPatients => {
                const assignedIds = new Set(assignedPatients.filter(p => p.selected).map(p => p.id));
                if (assignedIds.size > 0) {
                    if (!this.selectedDoctors.find(d => d.id === doctor.id)) {
                        this.selectedDoctors.push(doctor);
                    }
                    this.patientDtos.forEach(p => {
                        if (!p.assignments) p.assignments = {};
                        if (assignedIds.has(p.id)) {
                           p.assignments[doctor.id] = true;
                        }
                    });
                }
                completedRequests++;
                if (completedRequests === this.usersFilter.length) {
                    this.showLoadingMessage = false;
                }
            }, err => {
                 completedRequests++;
                 if (completedRequests === this.usersFilter.length) {
                    this.showLoadingMessage = false;
                 }
            });
        });
      } else {
         this.showLoadingMessage = false;
      }

    },
      err => this.showLoadingMessage = false);

    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => {
       this.filterPatients(value);
    });
  }


  filterPatients(searchValue: string) {
    if (!searchValue || searchValue.trim() === '') {
       this.filteredPatientDtos = this.patientDtos;
    } else {
       const lowerValue = searchValue.toLowerCase();
       this.filteredPatientDtos = this.patientDtos.filter(p => 
         (p.lastName + ", " + p.firstName).toLowerCase().includes(lowerValue) ||
         (p.firstName + " " + p.lastName).toLowerCase().includes(lowerValue)
       );
    }
  }

  redirectToIndex() {
    this.router.navigate(['/settings/doctors']);
  }

  save() {
    // Validate we have at least one doctor
    if (this.selectedDoctors.length === 0) {
      this.loadErrorMessage("Please select at least one doctor.");
      return;
    }

    const observables = this.selectedDoctors.map(doctor => {
      const selectedPatientIds = this.patientDtos
        .filter(p => p.assignments && p.assignments[doctor.id])
        .map(p => p.id);
      
      const userResident: any = { userId: doctor.id, residentIds: selectedPatientIds, pharmacyId: this.sharedService.pharmacyId };
      return this.settingsService.saveUserResidents(userResident);
    });

    this.showLoadingMessage = true;
    forkJoin(observables).subscribe(results => {
       const allSuccess = results.every((res: any) => res.success);
       this.showLoadingMessage = false;
       if (allSuccess) {
          this.sharedService.showTempSuccessMessage();
          this.redirectToIndex();
       } else {
          this.showErrorMessage = false;
          this.errorMessage = "Something went wrong with saving some assignments.";
       }
    }, err => {
      this.showLoadingMessage = false;
      this.showErrorMessage = false;
      this.errorMessage = "An error occurred while saving.";
    });
  }

  loadErrorMessage(message: any) {
    this.showErrorMessage = true;
    this.errorMessage = message.toString();
    window.scroll(0, 0);
  }

  validateFields(selecteds): string {
    var errors: string[] = [];
    var message: string = "";

    if (this.userId == null || this.userId == "")
      errors.push('Doctor');

    if (errors.length == 1) {
      message = "The field " + errors.join(", ") + " is mandatory."
    }
    else if (errors.length > 1) {
      message = "The fields " + errors.join(", ") + " are mandatories."
    }

    return message;
  }


  clearErrorMessage() {
    this.showErrorMessage = false;
    this.errorMessage = "";
  }

  //Autocomplete Residents element

  doctorSelectControl = new FormControl('');

  onDoctorSelect(event: any) {
    const doctorId = event.target.value;
    if (!doctorId) return;

    var user = this.usersFilter.find(f => f.id == doctorId);
    if (user) {
      // Check if already selected
      if (!this.selectedDoctors.find(d => d.id === user.id)) {
        this.selectedDoctors.push(user);
        
        // Load assignments for this doctor
        this.patientService.getPatientsByDoctorUserId(this.sharedService.pharmacyId, this.sharedService.facilityId, this.sharedService.getUserId(), true, user.id)
          .subscribe(assignedPatients => {
             const assignedIds = new Set(assignedPatients.filter(p => p.selected).map(p => p.id));
             this.patientDtos.forEach(p => {
               if (!p.assignments) p.assignments = {};
               p.assignments[user.id] = assignedIds.has(p.id);
             });
          });
      }
    }
    
    // Reset select
    this.doctorSelectControl.setValue('');
    this.condition = false;
    this.showSuccessMessage = false;
  }

  removeDoctor(doctor: any) {
    this.selectedDoctors = this.selectedDoctors.filter(d => d.id !== doctor.id);
  }

  toggleSelectAll(doctor: any, event: any) {
    const isChecked = event.target.checked;
    this.patientDtos.forEach(p => {
      if (!p.assignments) p.assignments = {};
      p.assignments[doctor.id] = isChecked;
    });
  }

  getData(): Observable<any[]> {
    if (this.usersFilter && this.usersFilter.length > 0) {
      return of(this.usersFilter);
    } else {
      return this.settingsService.getUserDoctors(this.sharedService.pharmacyId, this.sharedService.facilityId).pipe(
        map(data => {
          this.usersFilter = data;
          return data;
        })
      );
    }
  }

}

//Highlight text in autocomplete options

import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  transform(text: string, search): string {
    if (search && text && typeof search === 'string' && typeof text === 'string') {
      const pattern = search
        .replace(/[\-\[\]\/{}()*x+?.\\^$|]/g, '\\$&')
        .split(' ')
        .filter(t => t.length > 0)
        .join('|');
      const regex = new RegExp(pattern, 'gi');
      return search ? text.replace(regex, match => `<strong class="highlight">${match}</strong>`) : text;
    }
    return text;
  }
}
